import {isInfoTag} from '../domain/Tag.model.ts';

export const TagListUI = ({ data }) => {
  const { tags } = data;
  return (
    <div className="d-flex flex-row align-items-center gap-1 flex-wrap">
      {
        tags.map((tag, index) => {
            let badgeClass = '';
            if (tag.value === 'Combinable') {
              badgeClass = 'bg-warning text-white border-warning';
            } else if (isInfoTag(tag)) {
              badgeClass = 'border-primary text-primary';
            } else {
              badgeClass = 'border-warning text-warning';
            }
            return (
              <span key={index} className={`badge border ${badgeClass}`}>
                {tag.value}
              </span>
            );
          }
        )
      }
    </div>
  );
};
